import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import styles from './styles.module.scss'
import PostFeedModal from 'srcReact/components/popinsContent/PostFeedModal'
import { useDispatch, useSelector } from 'react-redux'
import { commonFeedActions } from '../../actions'
import { appConstantSettings } from 'srcReact/appConstantSettings'

function Options({
  feed,
  type,
  user,
  isFeedComments,
  isOrganizer,
  isGroupOrganizer,
  handleShowDeleteMessagePopup,
  writeToMember,
  showFlagReasonsPopup,
  entity
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [options, setOptions] = useState('')
  const [isPostModalOpen, setIsPostModalOpen] = useState(false)
  const {
    login: { user: loggedInUser },
    commonNewsfeed: { feeds }
  } = useSelector((state) => state)

  useEffect(() => {
    if (feed) {
      let items = []
      if (type !== 'feed' && !isFeedComments && isOrganizer) {
        let isPinned = feed.is_pinned_to_the_top == 1
        items.push({
          icon: isPinned ? 'unpin' : 'pin',
          text: isPinned ? t('global.unpin') : t('global.pin'),
          onClick: () => (isPinned ? handleUnpinMessage(feed.id) : handlePinMessage(feed.id))
        })
      }
      if (feed.id_user === loggedInUser?.id && feed.is_automatic_message !== 1) {
        items.push({ icon: 'edit', text: t('global.edit'), onClick: openPostModal })
      }
      if (feed.id_user !== loggedInUser?.id && user?.status === 'active') {
        items.push({
          icon: 'chat24',
          text: t('groupHome.options.writeToMember'),
          onClick: () => writeToMember(feed.id_user)
        })
      }
      if (feed.id_user !== loggedInUser?.id && feed.is_automatic_message !== 1) {
        items.push({
          icon: 'flag-icon',
          iconCSS: styles.iconCSS,
          text: t('moderationReport.flagPost.title'),
          onClick: () => {
            if (showFlagReasonsPopup) {
              showFlagReasonsPopup(feed)
            }
          }
        })
      }
      if (feed.id_user === loggedInUser?.id || isGroupOrganizer) {
        items.push({ icon: 'delete', text: t('global.delete'), onClick: () => handleShowDeleteMessagePopup(feed.id) })
      }
      setOptions(items)
    }
  }, [feed])

  const openPostModal = () => {
    setIsPostModalOpen(true)
  }

  const closePostModal = () => {
    setIsPostModalOpen(false)
  }

  const getCurrentQuantity = () => {
    return feeds.stats?.nextOffset < appConstantSettings.PAGINATION_QUANTITY
      ? appConstantSettings.PAGINATION_QUANTITY
      : feeds.stats?.nextOffset
  }

  const handlePinMessage = (feedId) => {
    dispatch(commonFeedActions.pinMessageToTop(feedId, getCurrentQuantity()))
  }

  const handleUnpinMessage = (feedId) => {
    dispatch(commonFeedActions.unpinMessageFromTop(feedId, getCurrentQuantity()))
  }

  return options.length > 0 ? (
    <React.Fragment>
      <ReactMenu
        ariaLabel={t('formlabel.openFeedOptions')}
        // direction='left'
        options={options}
        buttonIconSize='large'
        menuButtonCSS={styles.optionsButton}
        menuCSS={styles.optionsMenu}
      />
      {isPostModalOpen && (
        <PostFeedModal
          isEditMode={true}
          newsfeedId={feed.id_msg_newsfeed}
          isModalOpen={isPostModalOpen}
          closeModal={closePostModal}
          objectId={entity.id || feed.relation?.id}
          objectName={entity.title || feed.relation?.title}
          objectType={entity.type || feed.relation.type}
          showSuccessBanner={true}
          existingFeed={feed}
        />
      )}
    </React.Fragment>
  ) : (
    ''
  )
}

export default Options
